export const darkTheme = {
    box_shadow: '0 4px 8px rgba(255, 255, 255, 0.2)',
    background: '#121212',
    text: '#ffffff',
    accent: '#bb86fc',
    secondary: '#333',
    highlighting: '#575757',
    third: '#bdb2b2',
    lightDark: '#bdb2b2',
    hover: '#ffffff',
    mainHover: '#FFFFFF33',
    reviews: '#888',
    chatUser: '#333',
    leadLocation: '#999',
    filterButton: '#575757',
    filterHover: '#575757',
    statActive: '#575757',
    statText: '#ffffff',
    statMeta: '#ffffff',
    ellipsis: '#575757',
    requestButton: '#333',
    buttonRow: '#000000',
    licenseField: '#ffffff',
    viewBlue: 'rgb(29, 155, 240)',
    imagePadding: '0px',
    imageBorderRadius: '0px',
    rejected: '#999',
    addButton: '#000000',
    loginTitle: '#ffffff',
    loginActive: '#575757',
};

export const lightTheme = {
    box_shadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    background: '#ffffff',
    text: '#000000',
    accent: '#6200ee',
    secondary: '#ffffff',
    highlighting: '#f7f7f7',
    third: '#575757',
    lightDark: '#000000',
    hover: '#bdb2b2',
    mainHover: '#00000033',
    reviews: '#333',
    button_dark: '#000000',
    chatUser: '#F0F0F0',
    leadLocation: '#777',
    filterButton: '#f5f5f5',
    filterHover: '#f2f2f2',
    statActive: '#333',
    statText: '#666',
    statMeta: '#333',
    ellipsis: '#F0F0F0',
    requestButton: '#000000',
    buttonRow: '#ffffff',
    licenseField: '#111827',
    viewBlue: '#065fd4',
    imagePadding: '20px', 
    imageBorderRadius: '12px',
    rejected: '#555',
    addButton: '#f0f0f0',
    loginTitle: '#555',
    loginActive: '#000000',
};